<template>
  <div class="dummyImage" :style="renderStyle"></div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { mapState, mapActions } from "pinia";

export default {
  props: ["item", "index"],
  methods: {},
  computed: {
    ...mapState(useImageEditorStore, ["getReady"]),
    ready: function () {
      return this.getReady;
    },
    baseUrl: function () {
      return this.getConfigProp("baseUrl");
    },
    renderStyle: function () {
      if (this.ready) {
        return {
          backgroundImage: "url(" + this.item.imageSrc + ")"
        };
      }
      return {};
    }
  }
};
</script>
